import AutosaveLoader from './AutosaveLoader'

export default AutosaveLoader
